import React, { createContext, useContext, useState, useCallback } from "react";
import { apiAuth } from "../utils/http";
import { STORAGE_KEYS } from "../utils/constants";

const AuthContext = createContext(null);

function readStored(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEYS.token));
  const [user, setUser] = useState(() => readStored(STORAGE_KEYS.user));
  const [store, setStore] = useState(() => readStored(STORAGE_KEYS.store));

  const login = useCallback(async (username, password) => {
    // POST pos/v1/login — App\Http\Controllers\api\admin\v1\AuthController@login,
    // the same endpoint denzo-waiter and denzo-pos use. A driver account is a
    // store_user with the 'driver' role (granting list orders / update order
    // status / cancel order) — there's no separate driver auth type on the
    // backend, same as how a waiter account works today.
    const res = await apiAuth.post("login", { username, password });
    const { token: t, user: u, store: s } = res.data;
    localStorage.setItem(STORAGE_KEYS.token, t);
    localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(u));
    localStorage.setItem(STORAGE_KEYS.store, JSON.stringify(s));
    setToken(t);
    setUser(u);
    setStore(s);
    return u;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEYS.token);
    localStorage.removeItem(STORAGE_KEYS.user);
    localStorage.removeItem(STORAGE_KEYS.store);
    setToken(null);
    setUser(null);
    setStore(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, store, isAuthenticated: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
